// Fonte unica da prontidao da ficha do produto (W5, plano secao 5 W5).
// Usada pela faixa de prontidao (topo) E pelo rodape de publicar — "uma
// verdade, nao duas" (plano 6.3). RN03 (o que BLOQUEIA publicar) e
// preservado byte a byte do ActionsBar antigo: foto + descricao longa +
// categoria. SEO e Grade sao informativos (nao bloqueiam publish hoje).
import type { GridResponse, ProductDetail } from "./types";

export interface ReadinessChip {
  key: "photos" | "description" | "seo" | "grade";
  label: string;
  ok: boolean;
  hint: string;
}

export interface ReadinessResult {
  chips: ReadinessChip[];
  /** RN03 — igual ao ActionsBar de antes do redesign. */
  canPublish: boolean;
  missing: string[];
}

export function computeReadiness(
  product: ProductDetail,
  slug: string,
  grid?: Pick<GridResponse, "totals"> | null,
): ReadinessResult {
  const hasPhoto = product.media.some((m) => m.channels.includes(slug));
  const hasDescLong = !!(
    product.publication.description_long_override ?? product.entry.description_long_base
  );
  const hasCategory = !!(
    product.publication.category_id_override ?? (product.entry.category_ids?.length ?? 0) > 0
  );

  const missing: string[] = [];
  if (!hasPhoto) missing.push("foto");
  if (!hasDescLong) missing.push("descrição longa");
  if (!hasCategory) missing.push("categoria");

  const hasSeo = !!(product.publication.seo_title && product.publication.seo_meta_description);
  // Sem dado de grade ainda (backend antigo / 404) -> nao acusa problema (evita
  // falso negativo enquanto a API de grid nao esta no ar em todo ambiente).
  const gradeOk = grid ? grid.totals.enabled > 0 : true;

  const chips: ReadinessChip[] = [
    {
      key: "photos",
      label: "Fotos",
      ok: hasPhoto,
      hint: hasPhoto ? "Tem foto marcada para este canal." : "Nenhuma foto marcada para este canal.",
    },
    {
      key: "description",
      label: "Descrição",
      ok: hasDescLong,
      hint: hasDescLong
        ? "Tem descrição longa (base ou override)."
        : "Falta descrição longa (base ou override do canal).",
    },
    {
      key: "seo",
      label: "SEO",
      ok: hasSeo,
      hint: hasSeo ? "SEO title e meta description preenchidos." : "Falta SEO title ou meta description.",
    },
    {
      key: "grade",
      label: "Grade",
      ok: gradeOk,
      hint: gradeOk
        ? "Ao menos uma combinação ligada neste canal."
        : "Nenhuma combinação ligada neste canal — a loja não teria o que vender.",
    },
  ];

  return { chips, canPublish: missing.length === 0, missing };
}
